import { useMemo } from 'react';
import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const ByPeopleTypeAnual = () => {
    const { chartData } = useProfileChartsDataContext();

    const { subtitles, series } = useMemo(() => {
        // 1. Sort the items chronologically by year
        const items = (chartData?.byPeopleTypeAnual || [])
            .slice()
            .sort((a, b) => Number(a?.ano_estatistica || 0) - Number(b?.ano_estatistica || 0));

        // 2. Map the X-axis labels (years)
        const subtitles = items.map((item) => getYearLabel(item?.ano_estatistica));

        // 3. Dynamically find all unique people types present in the dataset
        const uniquePeopleTypes = Array.from(
            new Set(
                items.flatMap(item => (item?.tipos_pessoa || []).map(t => t.tipo_pessoa))
            )
        );

        // 4. Build the series arrays dynamically based on the found people types
        const series = uniquePeopleTypes.map(peopleTypeName => ({
            name: peopleTypeName,
            data: items.map(item => {
                const peopleTypeData = (item?.tipos_pessoa || []).find(t => t.tipo_pessoa === peopleTypeName);
                return Number(peopleTypeData?.total || 0); // Returns 0 if this specific people type doesn't exist in that year
            })
        }));

        return { subtitles, series };
    }, [chartData]);

    return (
        <SimpleBars
            title="Por Tipo de Pessoa (Anual)"
            horizontal={true}
            subtitles={subtitles}
            series={series}
            height={420}
            showDataLabels={true}
            stacked
        />
    );
};
